'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HTMLContent = require('../HTMLContent');

var _HTMLContent2 = _interopRequireDefault(_HTMLContent);

var _TheScoreArticleSponsor = require('../TheScoreArticleSponsor');

var _TheScoreArticleSponsor2 = _interopRequireDefault(_TheScoreArticleSponsor);

var _TimeAgo = require('../TimeAgo');

var _TimeAgo2 = _interopRequireDefault(_TimeAgo);

var _TheScoreArticleContentCardDetail = require('./TheScoreArticleContentCardDetail.css');

var _TheScoreArticleContentCardDetail2 = _interopRequireDefault(_TheScoreArticleContentCardDetail);

var _ContentCardImage = require('../ContentCardImage/ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _Matchup = require('../Matchup/Matchup');

var _Matchup2 = _interopRequireDefault(_Matchup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sponsorForRegion = function sponsorForRegion(sponsors, region) {
  return sponsors.find(function (sponsor) {
    return sponsor.region === region;
  }) || sponsors.find(function (sponsor) {
    return sponsor.region === 'global';
  });
};

var TheScoreArticleContentCardDetail = function TheScoreArticleContentCardDetail(props) {
  var sponsor = sponsorForRegion(props.sponsors, props.region);
  var hasSponsor = typeof sponsor !== 'undefined';
  var darkTheme = props.darkTheme ? 'dark' : '';

  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + ('article ' + darkTheme)
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'headerBox'
      },
      _react2.default.createElement('div', {
        className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'coverGradient'
      }),
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'header'
        },
        _react2.default.createElement(
          'h1',
          {
            className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'title'
          },
          props.text
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'byline'
          },
          props.byline
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'timeago'
          },
          _react2.default.createElement(_TimeAgo2.default, { date: props.publishedAt }),
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'imageAttribution'
            },
            props.imageAttribution
          )
        )
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'image'
        },
        _react2.default.createElement(_ContentCardImage2.default, { hideGradient: true, src: props.imageURL, alt: props.imageAltText })
      )
    ),
    hasSponsor && _react2.default.createElement(_TheScoreArticleSponsor2.default, { sponsor: sponsor }),
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'body'
      },
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _TheScoreArticleContentCardDetail2.default.__scopedHash + ' ' + 'content'
        },
        props.event && _react2.default.createElement(_Matchup2.default, { event: props.event, onMatchupCardClick: props.onMatchupCardClick }),
        _react2.default.createElement(_HTMLContent2.default, { content: props.content })
      )
    ),
    props.messengerShareButton,
    _react2.default.createElement(_style2.default, {
      styleId: _TheScoreArticleContentCardDetail2.default.__scopedHash,
      css: _TheScoreArticleContentCardDetail2.default.__scoped
    })
  );
};

TheScoreArticleContentCardDetail.propTypes = {
  byline: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]).isRequired,
  content: _propTypes2.default.string.isRequired,
  imageAttribution: _propTypes2.default.string,
  imageAltText: _propTypes2.default.string,
  imageURL: _propTypes2.default.string.isRequired,
  messengerShareButton: _propTypes2.default.node,
  publishedAt: _propTypes2.default.string.isRequired,
  region: _propTypes2.default.string,
  sponsors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    text: _propTypes2.default.string.isRequired,
    logo: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    region: _propTypes2.default.string.isRequired
  })),
  text: _propTypes2.default.string.isRequired,
  darkTheme: _propTypes2.default.bool,
  event: _propTypes2.default.shape({
    box_score: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    league: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    standings: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    api_uri: _propTypes2.default.string.isRequired,
    away_team: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    home_team: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    // eslint-disable-next-line react/forbid-prop-types
    tv_listings_by_country_code: _propTypes2.default.object.isRequired,
    game_date: _propTypes2.default.string.isRequired,
    event_status: _propTypes2.default.string.isRequired,
    top_25_rankings: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    playoff: _propTypes2.default.shape({
      description: _propTypes2.default.string
    }),
    aggregate_result: _propTypes2.default.shape({
      description: _propTypes2.default.string,
      short_description: _propTypes2.default.string,
      round_description: _propTypes2.default.string
    })
  }),
  onMatchupCardClick: _propTypes2.default.func
};

TheScoreArticleContentCardDetail.defaultProps = {
  imageAltText: '',
  imageAttribution: '',
  messengerShareButton: null,
  region: 'global',
  sponsors: [],
  darkTheme: false,
  event: null,
  onMatchupCardClick: null
};

exports.default = TheScoreArticleContentCardDetail;